import {gql} from 'apollo-boost';

export const GET_ADVISOR_ONLINE_SCHEDULE = gql`
  query getAdvisorOnlineSchedule($id : ID!){
    getAdvisorOnlineSchedule (
      id: $id
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo descriptionLocal descriptionEng remark externalLink externalPassword
      isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
        telephone email socialMedia availableTime isSpecialTeacher picturePath label
      }
      courseOutlineRegistration  { id }
      classSection { id sectionNo descriptionLocal descriptionEng
        startClassDate learnSpanNo examSpanNo studentRegisterQty
        classRoom{
          id
          nameLocal
          nameEng
          studentRegisterQty
          capacity
          startDate
          endDate
          courseOutlineRegistration{
            id
            courseOutline {
              id courseOutlineUnits{
                id seq nameLocal nameEng
              }
            }
          }
          degree{ id code }
          subjectGroup{ id code}
          classSection{
            id sectionNo descriptionLocal descriptionEng startClassDate
            learnSpanNo examSpanNo studentQty studentRegisterQty
          }
          teacher{
            id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
            telephone email availableTime socialMedia isSpecialTeacher
          }
          subject{
            id code nameLocal nameEng
          }
        }
        vdoSet{
          id code totalVdoLength
          vdoSetUnits {
            id unitSeq
            vdoSetTopics{
              id vdoStreamPath
              playbackUrl
              playbackStatus
              videoProvider
              bunnyVideoGuid
              bunnyStatus
            }
          }
        }
        courseOutline{
          id
          courseOutlineUnits{ id }
        }
      }
    }
  }
`;

export const GET_ADVISOR_ONLINE_SCHEDULES_BY_FILTER = gql`

  query getAdvisorOnlineSchedulesByFilter($advisorOnlineScheduleFilterInput: AdvisorOnlineScheduleFilterInput){
    getAdvisorOnlineSchedulesByFilter (
      advisorOnlineScheduleFilterInput:$advisorOnlineScheduleFilterInput
    ){
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo descriptionLocal descriptionEng remark externalLink externalPassword
      isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration{
        id
        courseOutline{
          id picturePath
        }
      }
      classSection { id sectionNo learnSpanNo studentRegisterQty studentQty
        classRoom{
          id capacity
        }
      }

    }
  }
`;

export const GET_ADVISOR_ONLINE_SCHEDULES_BY_FILTER_FOR_TABLE = gql`

  query getAdvisorOnlineSchedulesByFilter($advisorOnlineScheduleFilterInput: AdvisorOnlineScheduleFilterInput){
    getAdvisorOnlineSchedulesByFilter (
      advisorOnlineScheduleFilterInput: $advisorOnlineScheduleFilterInput
    ){
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo descriptionLocal descriptionEng remark externalLink externalPassword
      isEnabled
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      classSection { id sectionNo  }

    }
  }
`;

export const GET_ADVISOR_ONLINE_SCHEDULES_CURRENT_USER = gql`
  query getAdvisorOnlineSchedulesCurrentUser {
    getAdvisorOnlineSchedulesCurrentUser {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo descriptionLocal descriptionEng remark externalLink externalPassword
      isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo learnSpanNo }
    }
  }
`;
export const GET_ADVISOR_ONLINE_SCHEDULES = gql`
  query getAdvisorOnlineSchedules {
    getAdvisorOnlineSchedules {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo descriptionLocal descriptionEng remark externalLink externalPassword
      isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
    }
  }
`;

export const ADD_ADVISOR_ONLINE_SCHEDULE = gql`
  mutation addAdvisorOnlineSchedule(
    $degreeId: ID
    $subjectGroupId: ID
    $subjectId: ID
    $teacherId: ID
    $academicPeriodId: ID
    $courseOutlineRegistrationId: ID
    $classSectionId: ID
    $advisorOnlineScheduleInput: AdvisorOnlineScheduleInput!
  ) {
    addAdvisorOnlineSchedule(
      degreeId: $degreeId
      subjectGroupId: $subjectGroupId
      subjectId: $subjectId
      teacherId: $teacherId
      academicPeriodId: $academicPeriodId
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      advisorOnlineScheduleInput: $advisorOnlineScheduleInput
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo descriptionLocal descriptionEng remark externalLink externalPassword
      isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
    }
  }
`;

export const UPDATE_ADVISOR_ONLINE_SCHEDULE = gql`
  mutation updateAdvisorOnlineSchedule(
    $id: ID!,
    $degreeId: ID
    $subjectGroupId: ID
    $subjectId: ID
    $teacherId: ID
    $academicPeriodId: ID
    $courseOutlineRegistrationId: ID
    $classSectionId: ID
    $advisorOnlineScheduleInput: AdvisorOnlineScheduleInput!
  ) {
    updateAdvisorOnlineSchedule(
      id: $id
      degreeId: $degreeId
      subjectGroupId: $subjectGroupId
      subjectId: $subjectId
      teacherId: $teacherId
      academicPeriodId: $academicPeriodId
      courseOutlineRegistrationId: $courseOutlineRegistrationId
      classSectionId: $classSectionId
      advisorOnlineScheduleInput: $advisorOnlineScheduleInput
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo descriptionLocal descriptionEng remark externalLink externalPassword
      isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
    }
  }
`;

export const DELETE_ADVISOR_ONLINE_SCHEDULE = gql`
  mutation deleteAdvisorOnlineSchedule($id: ID!) {
    deleteAdvisorOnlineSchedule(
      id: $id
    ) {
      id periodCode degreeCode subjectGroupCode subjectCode subjectName
      teacherCode teacherFullName sectionNo topicLocal topicEng
      dateTimeFrom dateTimeTo descriptionLocal descriptionEng remark externalLink externalPassword
      isEnabled
      academicPeriod { id periodCode }
      degree { id code nameLocal nameEng }
      subjectGroup { id code nameLocal nameEng }
      subject { id code nameLocal nameEng }
      teacher  { id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath  }
      courseOutlineRegistration  { id }
      classSection { id sectionNo  }
    }
  }
`;

